module.exports = __webpack_public_path__ + "img/c03_buildingtechgiftofbalor_Normal_ua.b2ebd58a.webp";